import React from 'react'

function BriefCaseIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.333 4.66667H2.66634C1.92996 4.66667 1.33301 5.26363 1.33301 6.00001V12.6667C1.33301 13.4031 1.92996 14 2.66634 14H13.333C14.0694 14 14.6663 13.4031 14.6663 12.6667V6.00001C14.6663 5.26363 14.0694 4.66667 13.333 4.66667Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6663 14V3.33333C10.6663 2.97971 10.5259 2.64057 10.2758 2.39052C10.0258 2.14048 9.68663 2 9.33301 2H6.66634C6.31272 2 5.97358 2.14048 5.72353 2.39052C5.47348 2.64057 5.33301 2.97971 5.33301 3.33333V14"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BriefCaseIcon
